module.exports = __webpack_public_path__ + "static/media/dsc_logo.0d517ed6.png";